import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';

const TextAreaComp = ({
  label,
  value,
  onChange,
  onBlur,
  error,
  required,
  name,
  disabled = false,
  placeholder,
  fullWidth,
  errorMessage,
  paddingBottom,
  rows,
  readOnly,
  maxLength = 250,
  ...rest
}) => {
  const handleInputChange = event => {
    if (!event?.target) return;

    let inputValue = event.target.value;

    if (inputValue.startsWith(' ')) {
      inputValue = inputValue.trimStart();
    }

    if (inputValue.endsWith('  ')) {
      inputValue = inputValue.replace(/\s+$/, ' ');
    }

    onChange({
      target: {
        name: event.target.name,
        value: inputValue,
      },
    });
  };

  return (
    <TextField
      label={label}
      value={value}
      onChange={handleInputChange}
      onBlur={onBlur}
      error={error}
      required={required}
      name={name}
      disabled={disabled}
      placeholder={placeholder}
      fullWidth={fullWidth}
      multiline
      rows={rows}
      sx={{
        paddingBottom: paddingBottom || 0,
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '8px',
        },
      }}
      helperText={error ? errorMessage : ''}
      inputProps={{
        maxLength: maxLength,
      }}
      InputProps={{
        readOnly: readOnly,
      }}
      {...rest}
    />
  );
};

TextAreaComp.propTypes = {
  disabled: PropTypes.any,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  paddingBottom: PropTypes.number,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  rows: PropTypes.number,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
};

export default TextAreaComp;
